import { X } from "lucide-react";
import { CopyableEmail } from "@/components/common/CopyableEmail";
import { ImpersonationService } from "@/services/users/ImpersonationService";
import { useAuth } from "@/auth/AuthProvider";

interface ImpersonationBannerProps {
  children: React.ReactNode;
}

export const ImpersonationBanner = ({ children }: ImpersonationBannerProps) => {
  const { userProfile } = useAuth();

  if (!userProfile?.isImpersonating) {
    return <>{children}</>;
  }

  const displayName = userProfile.full_name || userProfile.email || "Unknown User";

  return (
    <div className="impersonation-border">
      <div className="h-full w-full overflow-hidden relative bg-genie-background">
        {children}
        {/* Floating impersonation badge */}
        <div className="fixed top-3 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/70 backdrop-blur-sm text-white text-xs shadow-lg">
          <span className="opacity-80">Impersonating:</span>
          <CopyableEmail email={displayName} className="font-medium" />
          <button
            onClick={() => ImpersonationService.stopImpersonation("/admin/users")}
            className="ml-1 p-0.5 rounded-full hover:bg-white/20 transition-colors"
            title="Exit Impersonation"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
};
